import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface GenerateStdJsonResponse {
  message: string;
  project_id?: string;
}

interface GenerateAuditReportRequest {
  projectId: string;
  userId: string;
}

interface AuditReportResponse {
  'Audit Date': string;
  'Compliance Data': {
    Category: string;
    'Compliance Type': string;
    Feature: string;
    Model: string;
    Reference: string;
    Severity: string;
  }[];
  'Final Audit Decision': {
    LLM: {
      'Compliance Score': number;
      'Features Score': number;
      'Final Decision': string;
      'MICROeAI Ethical Risk Score': number;
      'Risk Score': number;
    };
    ML: {
      'Compliance Score': number;
      'Features Score': number;
      'Final Decision': string;
      'MICROeAI Ethical Risk Score': number;
      'Risk Score': number;
    };
  };
  'Model Scores by Type': {
    LLM: {
      'Compliance Score': number;
      'Features Score': number;
      'Final Decision': string;
      'MICROeAI Ethical Risk Score': number;
      'Risk Score': number;
    };
    ML: {
      'Compliance Score': number;
      'Features Score': number;
      'Final Decision': string;
      'MICROeAI Ethical Risk Score': number;
      'Risk Score': number;
    };
  };
  'Project ID': string;
  'Project Name': string;
  'Report Header': string;
  Reviewer: string;
  'Risk Data': {
    Feature: string;
    'Key Concern': string;
    Model: string;
    'Recommended Action': string;
    'Risk Level': number;
  }[];
}

// Define the base API slice
export const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/project/`
  }),
  endpoints: builder => ({
    getProjectResults: builder.query({
      query: (projectId: string) => `features/${projectId}/results`
    }),

    // Existing mutation
    generateStandardizedProjectJson: builder.mutation<
      GenerateStdJsonResponse,
      { projectId: string; userId: string }
    >({
      query: body => ({
        url: 'features/generate-std-prj-json',
        method: 'POST',
        body
      })
    }),

    // ✅ New mutation: Generate Audit Report
    generateAuditReport: builder.mutation<
      AuditReportResponse,
      GenerateAuditReportRequest
    >({
      query: body => ({
        url: 'features/generate-audit-report',
        method: 'POST',
        body
      })
    })
  })
});

// Export the hooks
export const {
  useGetProjectResultsQuery,
  useGenerateStandardizedProjectJsonMutation,
  useGenerateAuditReportMutation
} = projectApi;
